var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1744V5.8139c0-1.9476 1.0034-2.932 2.973-2.932h16.054c1.9696 0 2.973.994 2.973 2.9331v11.3594c0 1.9491-1.0034 2.9432-2.973 2.9432H2.973c-1.9696 0-2.973-.9941-2.973-2.9432Zm1.624-1.0926 2.6972-2.4311c.3839-.3545.7778-.5203 1.2011-.5203.433 0 .8662.1769 1.2598.5314l1.7225 1.5541 4.2049-3.7604c.4218-.3839.8844-.5504 1.3961-.5504.5021 0 .9845.197 1.3977.5612l4.8727 4.5761V5.9254c0-.945-.5121-1.4177-1.4077-1.4177H3.0317c-.9056-.0019-1.4077.4708-1.4077 1.4177v10.1564Zm3.209-6.6836c0-1.2107.9844-2.2148 2.2051-2.2148 1.2108 0 2.2049 1.0033 2.2049 2.2148a2.2052 2.2052 0 0 1-4.41 0Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.60d8c4ac2fdfba32cb4d2dfa29760e3a.svg";
export { ForwardRef as ReactComponent };